import React from 'react';

const Hero = ({children}) => (
  <section className="hero is-large is-light">
    <div className="hero-body">
      <div className="container has-text-centered">
        <p className="title">
          Prijavi se
        </p>
        <p className="subtitle">
          Ako želiš da pratiš svoju statistiku
        </p>
      </div>
      {children}
      <div className="container has-text-centered">
        <span className="icon is-large">
          <i className="fas fa-3x fa-dove" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </section>
)

export default Hero;
